import React from 'react'

import Section from 'component/Section'
import SectionHeader from 'component/SectionHeader'
import SectionContent from 'component/SectionContent'
import Button from 'component/Button'
import HomeSlider from 'component/HomeSlider'
import ProductProfile from 'component/ProductProfile'
import LogoAstrea from 'svg/logos/astrea-horizontal.svg'
import LogoThemis from 'svg/logos/themis-horizontal.svg'

import { StaticImage } from 'gatsby-plugin-image'

const Hero = () => {
	return (
		<Section theme="hero">
			<SectionHeader
				supTitle="+100 mil profissionais aprovam"
				titleHeadingSize="1"
				title={
					<>
						Sua advocacia inteira em uma só aba.
						<br className="desktop" />
						&nbsp;Sua vida, muito mais leve.
					</>
				}
			/>
			<SectionContent>
				<HomeSlider
					items={[
						{
							id: 1,
							img: (
								<StaticImage
									src="../../../media-library/illustrations/astrea-workspace.svg"
									alt="Área de trabalho do software jurídico Astrea"
									placeholder="none"
									loading="eager"
									width={687}
									height={388}
									formats={['AUTO', 'WEBP', 'AVIF']}
								/>
							),
							text: (
								<>
									Automatize tarefas, reduza erros e cuide do que realmente
									importa: seus clientes e você.
									<Button
										title="Conheça o Astrea"
										className="btn-astrea"
										link="/astrea/"
									/>
								</>
							),
							video: 'Conheça o Astrea',
						},
						{
							id: 2,
							img: (
								<StaticImage
									src="../../../media-library/illustrations/themis-control-panel.svg"
									alt="Painel de controle do Themis para Escritórios de Advocacia"
									placeholder="none"
									loading="eager"
									width={627}
									height={413}
									formats={['AUTO', 'WEBP', 'AVIF']}
								/>
							),
							text: (
								<>
									Os departamentos jurídicos das melhores empresas do país usam
									e aprovam o software jurídico Themis.
									<Button
										title="Conheça o Themis para departamentos jurídicos"
										className="btn-themis"
										link="/themis-para-departamento-juridico/"
									/>
								</>
							),
							video: 'Conheça o Themis para departamento jurídico',
						},
						{
							id: 3,
							img: (
								<StaticImage
									src="../../../media-library/illustrations/themis-dashboard.svg"
									alt="Painel de controle do Themis para Departamentos Jurídicos"
									placeholder="none"
									loading="eager"
									width={687}
									height={438}
									formats={['AUTO', 'WEBP', 'AVIF']}
								/>
							),
							text: (
								<>
									Grandes escritórios precisam de um sistema jurídico completo e
									robusto como o Themis para grandes bancas.
									<Button
										title="Conheça o Themis para grandes bancas"
										className="btn-themis"
										link="/themis-para-escritorios-de-advocacia/"
									/>
								</>
							),
							video: 'Conheça o Themis para grandes bancas',
						},
					]}
				/>
			</SectionContent>

			<Section theme="profile">
				<SectionHeader
					titleHeadingSize="2"
					title={
						<>
							Você merece um software jurídico feito para a sua realidade.
							<br className="desktop" /> Selecione seu perfil e veja como
							transformar a sua advocacia:
						</>
					}
				/>
				<SectionContent>
					<ProductProfile
						buttons={[
							{
								id: 'astrea',
								text: 'Escritórios de advocacia e advogados',
								class: 'btn-beta',
							},
							{
								id: 'themis',
								text: 'Departamentos jurídicos ou grandes bancas',
								class: 'btn-gamma',
							},
						]}
						cards={[
							{
								id: 'astrea',
								logo: <LogoAstrea />,
								text:
									'Astrea é o parceiro que descomplica a rotina do seu escritório, conectando em um só lugar o que acontece na sua advocacia e no seu negócio. Com ele você tem mais controle e informação para decisões seguras, estratégicas e ágeis. E ainda conquista a liberdade que merece fora da advocacia.',
								buttons: [
									{
										id: 'astrea',
										text: 'Conheça o Astrea',
										link: '/astrea/',
										class: 'btn-astrea',
									},
								],
							},
							{
								id: 'themis',
								logo: <LogoThemis />,
								text:
									'Uma presença estratégica que guia sua equipe na tomada de decisões seguras, ajuda a reduzir riscos e harmoniza cada passo do seu departamento jurídico. O Themis te ajuda a manter o ritmo certo da sua empresa, conectado a todas as áreas.',
								buttons: [
									{
										id: 'themis-dj',
										text: 'Themis para departamentos jurídicos',
										link: '/themis-para-departamento-juridico/',
										class: 'btn-themis',
									},
									{
										id: 'themis-ea',
										text: 'Themis para grandes bancas',
										link: '/themis-para-escritorios-de-advocacia/',
										class: 'btn-themis',
									},
								],
							},
						]}
					/>
				</SectionContent>
			</Section>
		</Section>
	)
}

export default Hero
